module.exports = __webpack_public_path__ + "img/img_paperMaterial3_test.f6926b8c.png";